/**
 * Server-evaluated feature flags.
 *
 * @category data
 */

import { useQuery } from "@tanstack/react-query";

import { api, ApiResponse } from "_/utils";

const SCOPE = "features";
const KEYS = {
  flag: (flag: string) => [SCOPE, flag],
};

async function getFlag(flag: string): Promise<boolean> {
  const response = await api.get<ApiResponse<{ enabled: boolean }>>(
    `/features/${flag}`
  );
  return response.data.data.enabled;
}

/**
 * Evaluate a server-side feature flag for the current user.
 *
 * Flags are declared in `crates/common/src/features/flags.rs`, and evaluated against a
 * self-hosted Flipt server in staging/production, or `features.local.toml` in local development.
 */
export function useServerFeatureFlag(flag: string) {
  return useQuery({
    queryKey: KEYS.flag(flag),
    queryFn: () => getFlag(flag),
  });
}
